export enum RenderType {
  ICON = 'icon',
  BUTTON = 'button',
  GALLERY = 'gallery',
}
export enum VideoLinkType {
  YOUTUBE = 'youtube',
  GOOGLE_DRIVE = 'google-drive',
}

export enum VideoType {
  MP4 = 'mp4',
  URL = 'url',
}

// TODO: FINISH ALL THE TYPES
export enum PlacementIdsType {
  WEBINAR_PAGE = 'webinar_page',
  SUCCESS_STORIES_PAGE = 'success_story_page',
  DEST_TUT_PAGE = 'destination_videos_page',
  TUTORIAL_PAGE = 'tutorial_page',
  WELCOME_VIDEO = 'welcome-video',
  DASHBOARD = 'dashboard',
  PAYMENT = 'payment',
  SUBSCRIPTION = 'subscription',
  MANAGE_ORDER = 'manage-order',
  // ...
}

export type BaseVideoItem = {
  id: number;
  title: string;
  // placement_ids: string;
  // tags: string;
  video_path: string;
  video_type: VideoType;
  description: string;
  date_created: number;
};

export enum SortOptionsType {
    DATE_DESC = 'date-desc', // Default
    DATE_ASC = 'date-asc',
  }

export interface LocalVideoItem extends BaseVideoItem {
  placement_ids: PlacementIdsType[];
  tags: string[];
  embedData:
    | undefined
    | {
        id: string | undefined;
        type: VideoLinkType | undefined;
        thumbnail: string | undefined;
        src: string | undefined;
      };
}
export interface ApiResponseVideoItem extends BaseVideoItem {
  placement_ids: string;
  tags: string;
}

export type VideoListItem = {
  // TODO: Finish up the types ...
  id: number;
  video_id: string;
  title: string;
  type?: string;
  render_type?: string;
  placement_id?: string;
  videoList: ApiResponseVideoItem[];
};

export type TutorialVideosList = VideoListItem[];
